<template>
    <div>
        <v-btn rounded="lg" prepend-icon="mdi-email-sync-outline" class="gradient-color-primary" block @click="openChangeMailDialog">Email anpassen</v-btn>
        <v-dialog class="agency-change-mail-dialog" v-model="handleChangeMailDialog" persistent>
            <v-card class="agency-change-mail-card" rounded="lg">
                <v-card-title class="agency-change-mail-card-title">Email anpassen:</v-card-title>
                <v-card-text class="agency-change-mail-card-text">Passt die Email in der Datenbank und bei Stripe
                    an.</v-card-text>
                <v-text-field hide-details v-model="newMail" :label="`Aktuell: ${agency.email}`"></v-text-field>
                <v-divider class="agency-change-mail-divider"></v-divider>
                <div class="agency-change-mail-button-group">
                    <v-btn rounded="lg" :disabled="loading" color="error" @click="openChangeMailDialog">
                        Abbrechen
                    </v-btn>
                    <v-btn rounded="lg" :disabled="loading" class="gradient-color-primary" @click="changeMailAndSaveLog">
                        Anpassen
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    props: {
        agency: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            handleChangeMailDialog: false,
            newMail: ''
        }
    },
    computed: {
        ...mapState('agency', ['loading']),
    },
    methods: {
        ...mapActions('agency', ['changeMail', 'saveLog']),
        openChangeMailDialog() {
            this.handleChangeMailDialog = !this.handleChangeMailDialog;
            this.newMail = '';
        },
        async changeMailAndSaveLog() {
            const newMail = this.newMail;
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Regular expression for email validation

            if (!emailPattern.test(newMail)) {
                alert('Please enter a valid email address');
                return;
            }
            const updatedAgency = await this.$store.dispatch('agency/changeMail', { agencyId: this.agency._id, newMail });
            if (updatedAgency) {
                await this.$store.dispatch('agency/saveLog', {
                    agencyId: this.agency._id,
                    changes: [
                        {
                            date: new Date(),
                            description: `Mail changed to ${newMail}.`,
                            user: this.$store.state.loginAndOut.name // Fetch the name of the admin from the state
                        }
                    ],
                });
            }
            this.openChangeMailDialog();
        }
    }
}
</script>

<style lang="scss" scoped>
.agency-change-mail-dialog {
    max-width: 600px;
    margin: 0 auto;
}

.agency-change-mail-card {
    padding: 12px;
}

.agency-change-mail-card-title {
    font-size: 20px;
    font-weight: 600;
    padding: 4px 4px 24px 4px;
}

.agency-change-mail-divider {
    margin: 32px 0 12px 0;
}

.agency-change-mail-button-group {
    display: flex;
    justify-content: end;
    gap: 8px;
}

.agency-change-mail-card-text {
    padding: 4px 4px 8px 4px !important;
    font-size: 14px;
    font-weight: 500;
}
</style>